/* CannedSpaghetti.js */

'use strict';
const UserLocalStorage = require('./DataStorage/UserLocalStorage');
const CAN = require('./Addons/ControlAppNavAddon');
const ActivityMonitorAddon = require('./Addons/ActivityMonitorAddOn');
const FlatulentSpaghettiMasticator = require('./Addons/FlyingSpaghettiMonster');
const UserDataStorageFactory = require('./UserDataStorageFactory');
const Solutions = require('@gluenetworks/solution-definitions');

class CannedSpaghetti {
  constructor(Steve) {
    //App level modal user feedback
    try {
      // //register all the solution definitions from the game_center project
      // const SolutionRegisterer = require('@gluenetworks/game_center/src/app/solutionRegistrations'); // jshint ignore:line
      // // eslint-disable-next-line no-unused-vars
      // let registeredSolns = new SolutionRegisterer(Steve.di);
      Solutions.registerSolutions(Steve);

      //Solutions Manager Add On
      const SolutionsManager = require('../src/SolutionsManager');
      Steve.addOn('SolutionsManager', SolutionsManager, {addOnMode: true});

      const ModalUserFeedbackAddon = require('@gluenetworks/steve_ui_widgets').steveAddons
        .UserFeedback.ModalUserFeedback.rootLevel;
      Steve.addOn('ModalUserFeedback', ModalUserFeedbackAddon, {
        addOnMode: true,
        registrationFqn: '$teve.ui.userFeedback',
      });

      //Evented SDK Add-on this injects all the entities into the DI at initialize time
      const PlatformSdk = require('@gluenetworks/platform-sdk-remote');
      Steve.addOn('PlatformSdk', PlatformSdk.steveAddons.default, {
        addOnMode: true,
        registrationFqn: '$teve.privates.platformSdk',
      });

      //User Session Add On
      const UserSession = require('@gluenetworks/steve_core_user_session').steveAddons.control;
      Steve.addOn('UserSession', UserSession, {addOnMode: true});

      //License restriction Add On
      const LicenseRestrictionAddOn = require('./Addons/LicenseRestrictionAddon');
      Steve.addOn('LicenseRestriction', LicenseRestrictionAddOn, {addOnMode: true});
    } catch (e) {
      console.log(e);
      throw new Error(
        'the canned spaghetti module requires steve ui widgets, platform SDK and steve core user session'
      );
    }
    Steve.addOn('UserLocalStorage', UserLocalStorage, {addOnMode: false});
    Steve.addOn('ActivityMonitor', ActivityMonitorAddon, {addOnMode: true});
    //the storage must be initialize after userAuthenticated, so its moved to the ControlAppNavAddon.js -> _onAuthenticated()
    Steve.addOn('StorageFactory', UserDataStorageFactory, {addOnMode: true});
    Steve.addOn('ControlAppNav', CAN, {addOnMode: true});
    Steve.addOn('FSM', FlatulentSpaghettiMasticator, {addOnMode: true});
  }
}

module.exports = CannedSpaghetti;
module.exports.$inject = ['$teve.core'];
